import {
  ORDER_HISTORY_RESET_FILTERS,
  GET_ORG_DESCENDANTS,
  UPDATE_PAGE_OPTIONS, LOAD_ORDER_HISTORY_PAGE, UPDATE_ORDER_HISTORY_ALERT,
} from 'constants/ActionTypes';

export const loadOrderHistoryPage = (searchText) => ({ type: LOAD_ORDER_HISTORY_PAGE, searchText });
export const clearOrderHistoryFilters = () => ({ type: ORDER_HISTORY_RESET_FILTERS });
export const updatePageNumber = (pageNumber) => ({ type: UPDATE_PAGE_OPTIONS, pageOptions: { pageNumber } });
export const updatePageSize = (pageSize) => ({ type: UPDATE_PAGE_OPTIONS, pageOptions: { pageSize, pageNumber: 1 } });

export const getOrgDescendants = () => ({ type: GET_ORG_DESCENDANTS });
export const openOrderHistoryAlert = ({ title = '', severity = '', message = '' }) => ({
  type: UPDATE_ORDER_HISTORY_ALERT,
  orderHistoryAlert: {
    open: true,
    title,
    severity,
    message,
  },
});

export const closeOrderHistoryAlert = () => ({
  type: UPDATE_ORDER_HISTORY_ALERT,
  orderHistoryAlert: {
    open: false,
    title: '',
    severity: '',
    message: '',
  },
});
